import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseMaintenanceWorkflowForwardingsProps<T> = {
  workflowId?: string;
  filters?: {
    directiveEntryType?: string;
  };
  mapper?: (data: any) => T;
}

export const useMaintenanceWorkflowForwardings = <T,>({
  workflowId,
  filters: { directiveEntryType } = {},
  mapper = Mapper.default<T>(),
}: UseMaintenanceWorkflowForwardingsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const { data: { data, meta } = defaultTransformerResponse<T>(), ...rest } = useQuery({
    queryKey: ['maintenanceWorkflowForwardings', workflowId, directiveEntryType],
    queryFn: () => {
      return privateAxios.get(`/maintenance/workflows/${workflowId}/forwardings`, {
        params: {
          'q[directive_entry_type_eq]': directiveEntryType,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
    enabled: !!workflowId,
  });

  return { data, meta, ...rest }
}
